if(typeof require !== 'undefined'){
  var moment = require('moment');
  var finance = require('../lib/Finance.js');
}


class AirDnaChartSerializer {

  static monthlyRevenue(data, percentage = 1){
    let monthlyValues = this._extractValues(data.revenue);

    const datapoints = Object.keys(monthlyValues).map((month) => {
      const momentObj = moment().month(month - 1).date(1);
      const amount = monthlyValues[month] * percentage || 0;

      return {
        value: amount,
        date: momentObj.toDate(),
        tooltipEmphasis: '$' + finance.format(amount),
        tooltipDescription: momentObj.format('MMM') + ' Avg.',
      }
    });

    return {datapoints, yFormat: 'money'};
  }

  static monthlyOccupancy(data, percentage = 1){
    let monthlyValues = this._extractValues(data.occupancy);

    const datapoints = Object.keys(monthlyValues).map((month) => {
      const momentObj = moment().month(month - 1).date(1);
      let nights = Math.round((30 * monthlyValues[month]) * percentage);

      return {
        value: nights,
        date: momentObj.toDate(),
        tooltipEmphasis: `${nights} Nights`,
        tooltipDescription: momentObj.format('MMM') + ' Avg.',
      }
    });

    return {datapoints};
  }

  static nightlyRate(data, percentage = 1){
    let monthlyValues = this._extractValues(data.adr);

    const datapoints = Object.keys(monthlyValues).map((month) => {
      const momentObj = moment().month(month - 1).date(1);
      let amount = monthlyValues[month] * percentage || 0;

      return {
        value: amount,
        date: momentObj.toDate(),
        tooltipEmphasis: `$${finance.format(amount)}/night`,
        tooltipDescription: momentObj.format('MMM') + ' Avg.',
      }
    });

    return {datapoints, yFormat: 'money'};
  }

  static _extractValues(yearlyValues){
    yearlyValues = _.cloneDeep(yearlyValues);

    if(yearlyValues.ltm) delete yearlyValues.ltm;

    return this._flattenYears(yearlyValues);
  }

  static _flattenYears(datapoints){
    // Flatten into a single object with no year
    let monthlyValues = _.values(datapoints);
    return Object.assign(monthlyValues[0], monthlyValues[1]);
  }

}




if(typeof module !== 'undefined' && module.exports)
  module.exports = AirDnaChartSerializer;
else if(typeof window !== 'undefined')
  window.AirDnaChartSerializer = AirDnaChartSerializer;
